<ng-container *ngIf="allowed === 'true'; else noCashOutAllowedContainer">
  <header class="funds-in-header">
    <ng-container *ngIf="flow === 'deposit'; else withdraw">
      <p class="header">{{ sdfCardLabels?.landingPage?.cashInHeadr }}</p>
    </ng-container>
    <ng-template #withdraw>
      <p class="header">{{ sdfCardLabels?.landingPage?.cashOutHeadr }}</p>
    </ng-template>
  </header>
  <form novalidate class="estimate-form" *ngIf="form" [formGroup]="form">
    <app-custom-country-input-selector
      formControlName="country"
      [labels]="labels"
      [flow]="flow"
      [disableCashInCountry]="disableCashInCountry"
      [countriesFromStore]="cmsMappingCountries"
      [countryName]="countryName"
      [countryCodes]="countryCodes"
      [locale]="locale"
      [token]="token"
      [countryCode]="countryDetails?.code"
      (countryDataEmitter)="setStatePair($event)"
      [endpoint]="endpoint"
    >
    </app-custom-country-input-selector>
    <ng-container *ngIf="states && states.length > 0 && flow === 'withdraw'">
      <app-custom-state-input-selector
        [flow]="flow"
        [labels]="labels"
        formControlName="state"
        [states]="states"
        [stateCode]="stateCode"
      >
      </app-custom-state-input-selector>
    </ng-container>

    <ng-container *ngIf="(fxRateError$ | async) === false">
      <app-exchange-rate [fxRateObj]="fxRateObj"></app-exchange-rate>
    </ng-container>
    <app-amount-and-exchange-rate
      [fxRateError]="fxRateError$ | async"
      formControlName="amount"
      [enteredAmount]="amount"
      [disableAmount]="_disableAmount"
      [labels]="labels"
      [fxRateObj]="fxRateObj"
      [receiveCurrencies]="receiveCurrencies"
      [countryName]="countryName"
      [receiveCurrency]="receiveCurrency"
      (emitRecieveCurrency)="changeCurrency($event)"
      (formatAmount)="formatAmount()"
    >
    </app-amount-and-exchange-rate>

    <app-payout-options
      [google]="google"
      [flow]="flow"
      [labels]="labels"
      [selectedLocation]="selectedLocation"
      [enableSelectLocationBtn]="enableSelectLocationBtn$ | async"
      [selectedPaymentMethod]="selectedPaymentMethod"
      [isPaymentOptionsEnabled]="isPaymentOptionsEnabled"
      [isCashEnabled]="isCashEnabled"
      [isDebitEnabled]="isDebitEnabled"
      [isBankAccountEnabled]="isBankAccountEnabled"
      (changePaymentMethodEvent)="setPaymentMethod($event)"
    ></app-payout-options>

    <div class="divider-container">
      <div class="divider"></div>
    </div>

    <app-summary-section
      *ngIf="sdfCardLabels"
      [items]="summarySections$ | async"
      [displayTitle]="false"
      [title]="summarySectionsTitle"
    >
    </app-summary-section>

    <div class="exchange-footnote">
      <div class="footnote-container">
        <p class="footnote">
          {{ sdfCardLabels?.landingPage?.disclaimer?.one }}
        </p>
        <ng-container *ngIf="isWalletFeeEnabled; else noPartnerFee">
          <p class="footnote">{{"2 " +  sdfCardLabels?.common?.partnerWalletFeeFootnote}}</p>
        </ng-container>
        <ng-template #noPartnerFee>
          <p class="footnote">{{ "2 " +  sdfCardLabels?.landingPage?.disclaimer?.two}}</p>
        </ng-template>
        <p class="footnote">
          {{ getFxRateEstimateFootNote() }}
        </p>
      </div>
    </div>

    <div class="button-container">
      <ng-container *ngIf="flow === 'deposit' && isPaymentOptionsEnabled && !isLocationSelected; else continueButton">
        <app-submit-button
          [isFormValid]="!isAmountGreaterThanZero || !selectedPaymentMethod"
          [buttonText]="sdfCardLabels.common.continue"
          (buttonClick)="openLocationSelectorDialog()"
          [inputType]="'submit'"
        >
        </app-submit-button>
      </ng-container>
      <ng-template #continueButton>
        <app-submit-button
          [isFormValid]="!isFormvalid || (isPaymentOptionsEnabled && !selectedPaymentMethod)"
          [buttonText]="sdfCardLabels.common.continue"
          (buttonClick)="nextPage()"
          [inputType]="'submit'"
        >
        </app-submit-button>
      </ng-template>
    </div>
  </form>
</ng-container>
<ng-template #noCashOutAllowedContainer>
  <div class="no-cash-out-allowed">
    <p>{{ estimateLabels.noCashOutAllowed }} {{ _countryName }}</p>
  </div>
  <div class="mg-step-actions-row">
    <button
      color="primary"
      mat-raised-button
      type="submit"
      (click)="backToWalletDone()"
    >
      {{ estimateLabels.returnToWallet }}
    </button>
  </div>
</ng-template>
